import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, Grid, Typography} from '@material-ui/core'
import {compose} from 'redux'
import autobind from 'autobind-decorator'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { RouteComponentProps, withRouter } from 'react-router'
import { getCotation, updateCotation, duplicateCotation } from 'src/core/redux/action/cotationAction'
import { withToast } from 'src/shared/Toast'
import { WithToast } from 'src/shared/Toast/Toast'
import { formatDate } from 'src/core/i18n/date'
import PcDialog from 'src/shared/Dialog/PcDialog'
import Btn from 'src/shared/Btn/Btn'
import BtnActions from 'src/shared/Btn/BtnActions'
import { Page } from 'src/shared/RcPage'
import { getUserBestName } from 'src/shared/utils/helpers'

import CotationProvider, { withCotation, CtxCotation } from 'src/page/Consumer/Cotation/CotationProvider'
import Comment from 'src/page/Consumer/Cotation/Comment'
import History from 'src/page/Consumer/Cotation/History'
import Params from 'src/page/Consumer/Cotation/Params'
import Graph from 'src/page/Consumer/Cotation/Graph'
import Notification from 'src/page/Consumer/Cotation/Notification'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'
import Alert from 'src/shared/Alert/Alert'


const styles = (t: Theme) => createStyles({
    root: {
        padding: '40px 1rem',
        maxWidth: '95%'
    },
    chip: {
        margin: '4px',
        fontSize: '0.75rem',
        height: '26px'
    },
    cotationName: {
        fontSize: '2rem',
        marginBottom: t.spacing.unit * 2,
        color: t.palette.primary.main
    },
    cotationHeader: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'initial',
        [t.breakpoints.up('md')]: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingLeft: '3px'
        },
    },
    infoGeneral: {

    },
    actionBar: {
        display: 'flex',
        flexDirection: 'row',
        [t.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    actionBtn: {
        marginRight: t.spacing.unit
    },
    actionDuplicate: {
        // backgroundColor: '#039BE5'
    },
    actionComplete: {
        backgroundColor: '#45b14f'
    },
    infos: {
        fontWeight: 400
    }
});


interface IProps extends WithStyles<typeof styles>,
  WithI18n,
  WithToast,
  RouteComponentProps<any>,
  WithGlobalProgress,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>, CtxCotation {
    status: string;
}

interface IState {
    modalOpened: boolean;
    statusChange: string | undefined;
    action: string | undefined;
}

class Cotation extends React.Component<IProps, IState> {
    state = {
        modalOpened: false,
        statusChange: undefined,
        action: undefined
    }

    render(){
        const { t, classes, cotation, enterprise } = this.props;
        return(
            <Page className={classes.root}>
            <CotationProvider>
                {cotation &&
                    <Grid container >
                        <HelmetMeta title={cotation.cotation.name}/>
                        <Grid item xs={12}>
                            <Typography variant="title" className={classes.cotationName}>{cotation.cotation.name}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <div className={classes.cotationHeader}>
                                <div className={classes.infoGeneral}>
                                    <Typography variant="body2" className={classes.infos}>
                                        <span style={{fontWeight: 'bold'}}>{t.Cotation_table_column_last_update_at } : </span>
                                        {cotation.cotation.last_updated_at ? formatDate(new Date(cotation.cotation.last_updated_at)) : "-"}
                                    </Typography>
                                    <Typography variant="body2" className={classes.infos}>
                                        <span style={{fontWeight: 'bold'}}>{t.status } : </span>
                                        {this.statusRendering(cotation.cotation.status)}
                                    </Typography>
                                    {cotation.cotation.assigned_to &&
                                        <Typography variant="body2" className={classes.infos}>
                                            <span style={{fontWeight: 'bold'}}>Attribution de la cotation : </span>
                                            <span style={{fontWeight: 'bold', color: cotation.cotation.assigned_to === "client" ? '#0277BD' : 'rgba(237, 28, 36, 1)'}}>
                                                {cotation.cotation.assigned_to === "client" ? "CLIENT" : "ARKEA"}
                                            </span>
                                        </Typography>
                                    }
                                    <br/>
                                </div>
                                <div className={classes.infoGeneral}>
                                    {cotation.user &&
                                        <Typography variant="body2" className={classes.infos}>
                                            <span style={{fontWeight: 'bold'}}>Demande initiée par : </span>
                                            {getUserBestName(cotation.user)}
                                        </Typography>
                                    }
                                    {enterprise &&
                                        <Typography variant="body2" className={classes.infos}>
                                            <span style={{fontWeight: 'bold'}}>Client : </span>
                                            {enterprise.name}
                                        </Typography>
                                    }
                                </div>
                                <div>
                                    <div className={classes.actionBar}>
                                        <Btn
                                            color="primary"
                                            variant="raised"
                                            className={`${classes.actionBtn} ${classes.actionDuplicate}`}
                                            onClick={() => this.toogleModal("duplicate",undefined)}
                                        >
                                            Dupliquer la cotation
                                        </Btn>
                                        {cotation.cotation.status === "DRAFT" &&
                                            <Btn
                                                color="primary"
                                                variant="raised"
                                                onClick={() => this.toogleModal("update","LIVE")}
                                                className={classes.actionBtn}
                                            >
                                                Passer en live
                                            </Btn>
                                        }
                                        {cotation.cotation.status === "LIVE" &&
                                            <>
                                                <Btn
                                                    color="primary"
                                                    variant="raised"
                                                    onClick={() => this.toogleModal("update","EXPIRED")}
                                                    className={classes.actionBtn}
                                                >
                                                    Passer en expirée
                                                </Btn>
                                            </>
                                        }
                                        {cotation.cotation.status === "EXPIRED" &&
                                            <Btn
                                                color="primary"
                                                variant="raised"
                                                onClick={() => this.toogleModal("update","LIVE")}
                                                className={classes.actionBtn}
                                            >
                                                Passer en finalisée
                                            </Btn>
                                        }
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} alignContent="flex-end">
                            <Alert type="warning">Cette page vous permet d'obtenir des cotations indicatives mais ne permet pas de traiter des opérations en ligne avec la Salle des Marchés.</Alert>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <div>
                                <Params />
                                <Graph />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <div>
                                <Comment /> 
                                <History />
                                <Notification />
                            </div>
                        </Grid>
                        <PcDialog
                            open={this.state.modalOpened}
                            title={
                                <>
                                    {this.state.action === "duplicate" && t.Cotation_table_duplicate_modal_title}
                                    {this.state.statusChange === "EXPIRED" && t.Cotation_table_pass_for_expire_modal_title}
                                    {this.state.statusChange === "DONE" && t.Cotation_table_pass_for_done_modal_title}
                                </>
                            }
                            maxWidth="sm"
                            fullWidth={true}
                            actions={
                            <BtnActions
                                cancelHandler={() => this.toogleModal(undefined, undefined)}
                                confirmHandler={this.state.action === "duplicate" ? this.duplicate : this.changeStatus}
                            />
                            }
                        >
                            {this.state.action === "duplicate" && t.Cotation_table_duplicate_modal_content}
                            {this.state.statusChange === "EXPIRED" && t.Cotation_table_pass_for_expire_modal_content}
                            {this.state.statusChange === "DONE" && t.Cotation_table_pass_for_done_modal_content}
                        </PcDialog>
                    </Grid>
                }
            </CotationProvider>
            </Page>
        )
    }

    @autobind
    private statusRendering(status) {
        const { t } = this.props;
        return ({
            LIVE: t.Cotation_status_LIVE,
            EXPIRED: t.Cotation_status_EXPIRED,
            DONE: t.Cotation_status_DONE,
            DRAFT: t.Cotation_status_DRAFT,
        } [ status ] || "-")
    }

    @autobind
    private duplicate(){
        const {match, enterprise, promisesWithProgress, toastError} = this.props
        promisesWithProgress(
            this.props.duplicate(match.params.productType, match.params.cotationId).then(res => {
                this.props.history.push({
                    pathname: `/ptf/enterprise/${enterprise.id}/cotation-duplicate/${match.params.productType}/${res.id}`,
                    state: { 
                        duplicate: true,
                        productType: match.params.productType,
                        id: res.id
                    }
                })
            }).catch(err => toastError(err.msg))
        )
    }

    @autobind
    private changeStatus(){
        const {promisesWithProgress, toastError, toastSuccess, match, t, changeStatusCotation} = this.props
        promisesWithProgress(
            changeStatusCotation({cotation: {status: this.state.statusChange}}, match.params.productType, match.params.cotationId)
                .then(res => {
                    toastSuccess(t.action_success)
                    this.toogleModal(undefined, undefined)
                })
                .catch(err => toastError(err.msg)),
        )
    }

    @autobind
    private toogleModal(action: string | undefined, status: string | undefined){
        this.setState({statusChange: status, action})
        setTimeout(() => {
            this.setState({modalOpened: !this.state.modalOpened})
        }, 1000)
    }

}

const state2props = (state: RootState) => ({
    enterprise: state.accountInfo.enterpriseSelected,
    consumer: state.consumer.entity,
    cotation: state.cotation.entity,
    categories: state.categories.entities,
    mapName: state.utils.mapCategories,
    mapProductType: state.utils.mapProductType,
    productTypes: state.utils.productTypes,
});

const dispatch2props = dispatch => ({
    fetch: (productType: string, id: string) => dispatch(getCotation(productType, id)),
    duplicate: (productType: string, id: string) => dispatch(duplicateCotation(productType, id)),
    changeStatusCotation: (data: any, productType: string, id: string) => dispatch(updateCotation(data, productType, id))
});


export default compose(
  withCotation,
  withI18n,
  withGlobalProgress,
  withToast,
  withRouter,
  connect(state2props, dispatch2props),
  withStyles(styles)
)(Cotation)



// WEBPACK FOOTER //
// ./src/page/Consumer/Cotation/Cotation.tsx